export const footerLinks = {
  'ویلاهای شمال': [
    {
      description: 'اجاره ویلا در چالوس',
      link: '/search/city/چالوس',
    },
    {
      description: 'اجاره ویلا در کلاردشت',
      link: '/search/city/کلاردشت',
    },
    {
      description: 'اجاره ویلا در رشت',
      link: '/search/city/رشت',
    },
    {
      description: 'اجاره ویلا در بندرانزلی',
      link: '/search/city/بندرانزلی',
    },
    {
      description: 'اجاره ویلا در فومن',
      link: '/search/city/فومن',
    },
    {
      description: 'اجاره ویلا در بابلسر',
      link: '/search/city/بابلسر',
    },
    {
      description: 'اجاره ویلا در محمود آباد',
      link: '/search/city/محمود%20آباد',
    },
    {
      description: 'اجاره ویلا در فریدون کنار',
      link: '/search/city/فریدون%20کنار',
    },
    {
      description: 'اجاره ویلا در نوشهر',
      link: '/search/city/نوشهر',
    },
    {
      description: 'اجاره ویلا در رامسر',
      link: '/search/city/رامسر',
    },
    {
      description: 'اجاره ویلا متل قو',
      link: '/search/city/متل%20قوسلمان%20شهر',
    },
  ],
  'ویلاهای جنوب': [
    {
      description: 'اجاره ویلا در شیراز',
      link: '/search/city/شیراز',
    },
    {
      description: 'اجاره ویلا در بندرعباس',
      link: '/search/city/بندرعباس',
    },
    {
      description: 'اجاره ویلا در هرمزگان',
      link: '/search/province/هرمزگان',
    },
    {
      description: 'اجاره ویلا در قشم',
      link: '/search/city/قشم',
    },
    {
      description: 'اجاره ویلا در کیش',
      link: '/search/city/کیش',
    },
    {
      description: 'اجاره ویلا در جزیره هرمز',
      link: '/search/city/جزیره%20هرمز',
    },
    {
      description: 'اجاره ویلا در یزد',
      link: '/search/city/یزد',
    },
    {
      description: 'اجاره ویلا در همدان',
      link: '/search/city/همدان',
    },
  ],
  'ویلاهای اطراف تهران': [
    {
      description: 'اجاره ویلا در تهران',
      link: '/search/city/تهران',
    },
    {
      description: 'اجاره ویلا در بومهن',
      link: '/search/city/بومهن',
    },
    {
      description: 'اجاره ویلا در رودهن',
      link: '/search/city/رودهن',
    },
    {
      description: 'اجاره ویلا در دماوند',
      link: '/search/city/دماوند',
    },
    {
      description: 'اجاره ویلا در لواسان',
      link: '/search/city/لواسان',
    },
    {
      description: 'اجاره ویلا در طالقان',
      link: '/search/city/طالقان',
    },
    {
      description: 'اجاره ویلا در کردان',
      link: '/search/city/کردان',
    },
    {
      description: 'اجاره ویلا در فیروزکوه',
      link: '/search/city/فیروزکوه',
    },
    {
      description: 'اجاره ویلا در شهریار',
      link: '/search/city/شهریار',
    },
  ],
  سایر: [
    {
      description: 'اجاره ویلا جنگلی',
      link: '/search?forest=1',
    },
    {
      description: 'اجاره ویلا ساحلی',
      link: '/search?coastal=1',
    },
    {
      description: 'اجاره ویلا استخردار',
      link: '/search?pool=1',
    },
    {
      description: 'اجاره ویلا با استخر سرپوشیده',
      link: '/search?indoor_pool=1',
    },
    {
      description: 'اجاره ویلا با استخر روباز',
      link: '/search?outdoor_pool=1',
    },
    {
      description: 'اجاره ویلا شهری',
      link: '/search?in_town=1',
    },
    {
      description: 'اجاره ویلا کوهستانی',
      link: '/search?mountain=1',
    },
    {
      description: 'اجاره ویلا کویری',
      link: '/search?desert=1',
    },
    {
      description: 'اجاره کلبه چوبی و جنگلی',
      link: '/all-cottage',
    },
    {
      description: 'اجاره کلبه سوئیسی',
      link: '/search?swiss-cottage=1',
    },
    {
      description: 'رزرو اقامتگاه بومگردی',
      link: '/all-boomgardi',
    },
    {
      description: 'اجاره خانه و آپارتمان مبله در تهران',
      link: '/search/city/تهران?apartment=1',
    },
  ],
}
